import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
import { I18nextProvider } from 'react-i18next';
import i18n from '../src/config/i18n';
import { installRedactingConsole } from 'config/redactConsole';

// EV-010。コンソールの記録にアクセス用トークンを出さない（画面の各所の console.error・log などに効かせる）。
installRedactingConsole();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
    
  </React.StrictMode>
);